module.exports = __webpack_public_path__ + "img/nc.79c50c6e.png";